<template>
  <md-dialog
    :md-active.sync="show"
    @md-opened="openDialog"
    @md-clicked-outside="closeDialog"
    @md-closed="closeDialog"
    :class="state === 'prompt' ? '' : 'warning-dialog'"
  >
    <md-dialog-title>Enroll user</md-dialog-title>

    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div v-if="state === 'prompt'">
        <div class="md-subheading warning-text">
          This action generates an activation code for this user, You must deliver it to the user inorder to activate
          Saman Authenticator application.
        </div>
        <div dir="rtl">
          <md-button class="md-primary" @click="enrollUser">Next</md-button>
          <md-button @click="closeDialog">close</md-button>
        </div>
      </div>

      <div v-else class="md-dialog-content">
        User_id:
        <div class="user-id">
          <div class="key">
            <small class="holder">{{ userID }}</small>
          </div>
        </div>
        Username:
        <div class="user-id">
          <div class="key">
            <small class="holder">{{ username }}</small>
          </div>
        </div>

        Activation QRCode:
        <br />
        <div class="md-layout md-alignment-center">
          <img :src="`${activationBarcode}?image`" :alt="activationCode" class="md-layout-item md-xlarge-size-40 md-large-size-50 md-medium-size-60 md-small-size-70" />
        </div>
        <div class="activation-code">
          <div class="key">
            <small class="holder">{{ activationCode }}</small>
          </div>
          <md-button class="btn" @click="copyActivationCode">
            <md-icon>file_copy</md-icon>
            Copy to clipboard
          </md-button>
        </div>
        <div dir="rtl">
          <md-button class="md-primary" @click="closeDialog">OK</md-button>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default {
  name: "EnrollApplicationUser",
  props: ["show", "application_user_pk"],
  data() {
    return {
      state: "prompt",
      userID: "",
      username: "",
      activationCode: "",
      activationBarcode: ""
    };
  },
  methods: {
    copyActivationCode: function() {
      let that = this;
      navigator.clipboard
        .writeText(this.activationCode)
        .then(function() {
          that.notifyVue("top", "right", "Successfully copied! ");
        })
        .catch(/* */);
    },
    closeDialog: function() {
      this.state = "prompt";
      this.userID = "";
      this.username = "";
      this.activationCode = "";
      this.activationBarcode = "";
      this.$emit("close");
    },
    openDialog: function() {},
    enrollUser: async function() {
      const response = await this.$api.enrollUser({
        params: {
          application_user_pk: this.application_user_pk
        }
      });

      this.username = response.parsedData.username;
      this.userID = response.parsedData.user_id;
      this.activationCode = response.parsedData.activation_code;
      this.activationBarcode = response.parsedData.activation_barcode;
      this.state = "enrolled";
    },
    notifyVue: function(verticalAlign, horizontalAlign, message) {
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "success"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-dialog .md-dialog-content {
  padding: 12px 16px;
}

.user-id {
  margin: 8px 0 16px 0;

  .btn {
    text-transform: none;
    margin-top: 8px;
    margin-left: 0;
    font-size: x-small;
    /*.md-ripple{*/
    /*    padding: 0px;*/
    /*}*/
    .md-icon {
      font-size: 16px !important;
    }
  }

  .holder {
    text-align: center;
    display: inline-block;
    width: 100%;
    padding: 4px 4px;
    border-style: solid;
    border-color: gray;
    border-width: 1px;
    background-color: gainsboro;
    border-radius: 4px;
    overflow-x: auto;
    font-size: 0.9em;
  }
}

.size-test {
  width: 100%;
}

.user-id .md-ripple {
  padding: 0 !important;
}

.btm-padding {
  padding-bottom: 32px;
}

.activation-code {
  margin: 8px 0 16px 0;

  .btn {
    text-transform: none;
    margin-top: 8px;
    margin-left: 0;
    font-size: x-small;
    /*.md-ripple{*/
    /*    padding: 0px;*/
    /*}*/
    .md-icon {
      font-size: 16px !important;
    }
  }

  .holder {
    text-align: center;
    display: inline-block;
    width: 100%;
    padding: 4px 4px;
    border-style: solid;
    border-color: gray;
    border-width: 1px;
    background-color: gainsboro;
    border-radius: 4px;
    overflow-x: auto;
    white-space: nowrap;
    font-size: 0.9em;
  }
}

.activation-code .md-ripple {
  padding: 0 !important;
}
</style>
